import React from "react";
import { template } from "@reco-m/core";
import { Namespaces } from "@reco-w/office-models";
import { ViewComponent, } from "@reco-w/core-ui";
import {BackTop, Button, Col, Modal, Popover, Row} from "antd";
import { Consulting } from "src/apps/consulting/consulting";

export namespace BackTopBox {
    export interface IProps extends ViewComponent.IProps {
        formItemLayout?: any;
        isModal?: boolean;
        modalCancel: () => void;
    }

    export interface IState extends ViewComponent.IState {
    }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        namespace = Namespaces.office;

        render(): React.ReactNode {
            const { state } = this.props,
                isModalVisible = state!.isModalVisible,
                tipsVisible = state!.tipsVisible;
            return <>
                <div className="backTop-box">
                    {isModalVisible && <Consulting.Page orderCode="guanwsy" isModal={true} modalCancel={() => {
                        this.dispatch({ type: "input", data: { isModalVisible: false } });
                    }}></Consulting.Page>}
                    {tipsVisible && (
                        <Modal
                            // title="提示信息"
                            open={tipsVisible}
                            closable={false}
                            maskClosable={false}
                            onOk={() => this.dispatch({ type: "input", data: { tipsVisible: false } })}
                            onCancel={() => this.dispatch({ type: "input", data: { tipsVisible: false } })}
                            footer={[]}
                            wrapClassName="tips-modal"
                            centered={true}
                        >
                            <div className="tips-modal-title">提示信息</div>
                            <div className="tips-write mt15">
                                您好，您在该平台登记的个人信息将会采用加密存储，且可能会被平台基于优化用户体验的目的进行共享，且默认情况下数据会在平台保存一年，若点击“确定”按钮视为您同意以上告知内容。如果需要提前删除申请信息请通过平台的咨询热线联系数据安全负责人，谢谢!
                            </div>
                            <div className="text-center mt15"><Button type="primary" onClick={() => this.dispatch({ type: "input", data: { tipsVisible: false, isModalVisible: true } })}>确定</Button></div>
                        </Modal>
                    )}
                    <ul>
                        <Popover placement="left" content={<Row>
                            <Col span={24}>
                                <img width="159px" height="159px" src="assets/images/gw/code1.jpg" />
                            </Col>
                        </Row>}>
                            <li>
                                <div className="item"><i className="wt wt-wechat" /></div>
                            </li>
                        </Popover>
                        <Popover placement="left" content={<Row>
                            <Col span={24}>
                                <div className="size-16 gray-tow-color">咨询热线：</div>
                                <div className="size-24 gray-tow-color">400-026-9898</div>
                            </Col>
                        </Row>}>
                            <li>
                                <div className="item"><i className="wt wt-mobile" /></div>
                            </li>
                        </Popover>
                        <li>
                            <div className="item" onClick={() => {
                                this.dispatch({ type: "input", data: { tipsVisible: true } });
                            }}><i className="wt wt-edit" /></div>
                        </li>
                        {/* <li className="activity" onClick={() => {
                            this.goTo('/inn?idx=1')
                        }}>
                            <div className="item">
                                <i className="wt wt-gift" />
                                <div className="desc">
                                    促销活动
                                    </div>
                            </div>
                        </li> */}
                    </ul>
                    <BackTop className="home-backTop">
                        <div className="box">
                            <i className="icon iconzhiding" />
                        </div>
                    </BackTop>
                </div>
            </>
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.office]);
}
